import { BaseModel } from "@/models/base.model"
import { type IFile } from "@/interfaces/api/file.interface"
import { FileHelper } from "@/helper/file-helper.ts"
import { FileRenderTypes } from "@/enums/file-render-types.ts"
import { ModelFactory } from "@/factories/model-factory.ts"

export class File extends BaseModel implements IFile {
  public static className = "File" // Used for socket communication.
  public static verboseName = "bestand"

  id: string
  fileRelation: string

  originalFile?: string
  derivedFiles: File[]

  originalName: string
  extension: string
  url: string
  thumbUrl: string

  constructor(file: IFile, managed = false) {
    super(file)

    this.id = file.id
    this.fileRelation = file.fileRelation

    this.originalFile = file.originalFile
    this.derivedFiles = ModelFactory.childModels(File, file.derivedFiles, managed)

    this.originalName = file.originalName
    this.extension = file.extension
    this.url = file.url
    this.thumbUrl = file.thumbUrl
  }

  public getDerivedFile() {
    // Currently only one derived file is supported on the backend. Simply return the first one.
    return this.derivedFiles[0] ?? null
  }

  public getOriginalFileNameIncludingExtension() {
    return `${this.originalName}.${this.extension}`
  }

  public isImage() {
    return FileHelper.getFileRenderType(this) === FileRenderTypes.IMAGE
  }

  public isDocument() {
    return FileHelper.getFileRenderType(this) === FileRenderTypes.DOCUMENT
  }

  public isEmail() {
    return FileHelper.getFileRenderType(this) === FileRenderTypes.EMAIL
  }

  public isWordDocument() {
    return FileHelper.isWordDocument(this)
  }

  public isSpreadsheet() {
    return FileHelper.isSpreadsheet(this)
  }

  public isPdfDocument() {
    return FileHelper.isPdfDocument(this)
  }
}
